/**
 * Middleware to close all open dialogs when navigating between different routes.
 *
 * @param {Object} to - The route being navigated to
 * @param {string} to.path - Path of the destination route
 * @param {Object} from - The route being navigated from
 * @param {string} from.path - Path of the origin route
 *
 * @returns {void}
 *
 * @description
 * - Closes all open dialogs when the route path changes
 * - Prevents dialogs from persisting across different pages
 *
 * @remarks
 * - Uses the `useDialog()` composable to manage dialog state
 * - Only triggers dialog closure when moving to a different route
 *
 * @example
 *  When navigating from '/home' to '/products'
 *  Closes all open dialogs
 */
export default defineNuxtRouteMiddleware((to, from) => {
  const { closeAllDialogs } = useDialog()
  if (from.path !== to.path) {
    closeAllDialogs()
  }
})
